/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { View } from 'react-native';
import { operationalFilterStyles as opStyles } from '../../../shared/filters/operationalFilters.styles';
import { MasterFilterCompactPicker } from '../../../shared/filters/MasterFilterCompactPicker';
import type { ReportsVentasLayoutMode } from '../reportsVentasLayout';

type Props = {
  disabled?: boolean;
  active: boolean;
  caption: string;
  valueLabel: string;
  emptyLabel: string;
  onPress: () => void;
  accessibilityLabel: string;
  layout?: ReportsVentasLayoutMode;
};

/** Selector de alcance (operador / cliente) alineado al kit operativo. */
export function ReportsScopeEntityFilterPicker({
  disabled = false,
  active,
  caption,
  valueLabel,
  emptyLabel,
  onPress,
  accessibilityLabel,
  layout,
}: Props) {
  const displayValue = active ? valueLabel : emptyLabel;
  const layoutWide = layout?.layoutWide ?? false;

  return (
    <View style={layoutWide ? opStyles.wideToolbarGroup : opStyles.mobilePickerGridItem}>
      <MasterFilterCompactPicker
        caption={caption}
        value={displayValue}
        active={active}
        dense={!layoutWide}
        onPress={() => !disabled && onPress()}
        accessibilityLabel={accessibilityLabel}
      />
    </View>
  );
}
